import { useState } from "react";
import { Button } from "@/ui";
import { activityStore } from "@/services/client";
import { EmptyState, SectionHead } from "@/features/shell/EmptyState";
import { ActivityCard } from "./ActivityCard";
import { useDashboard } from "./dashboard";

/** Defaults for activities created from the minimal web form. */
const NEW_ACTIVITY_ICON = "star";
const NEW_ACTIVITY_COLOR = "#007AFF";
const SAVE_FAILED = "Could not save the change — check your connection.";

/** The activity grid: every activity as a dashboard tile. */
export function ActivitiesPage() {
  const dashboard = useDashboard();
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    const shortName = name.trim();
    if (!shortName) return;
    setError(null);
    setName("");
    try {
      await activityStore.create({
        shortName,
        icon: NEW_ACTIVITY_ICON,
        colorHex: NEW_ACTIVITY_COLOR,
        purpose: "",
      });
    } catch {
      setError(SAVE_FAILED);
    }
  }

  async function remove(id: string) {
    setError(null);
    try {
      await activityStore.remove(id);
    } catch {
      setError(SAVE_FAILED);
    }
  }

  return (
    <main className="console">
      <form className="auth-form activity-form" onSubmit={create}>
        <input
          type="text"
          placeholder="New activity name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="a8-input"
        />
        <Button type="submit" disabled={!name.trim()}>
          Add activity
        </Button>
      </form>
      {error && <p className="auth-error">{error}</p>}

      <SectionHead title="Your activities" count={dashboard.length} />
      {dashboard.length === 0 ? (
        <EmptyState
          title="No activities yet"
          hint="Add your first one above — goals, plans, and metrics all hang off an activity."
        />
      ) : (
        <ul className="card-list">
          {dashboard.map((view) => (
            <ActivityCard key={view.activity.id} {...view} onDelete={(id) => void remove(id)} />
          ))}
        </ul>
      )}
    </main>
  );
}
